<div [id]="content?._id" class="show-content">
  @switch (content?.contentType) {
    <!--  {{content?.id}} - {{content?.type}}-->
    @case ('text') {
      <app-text-content [content]="content"></app-text-content>
    }
    @case ('app') {
      <app-app-and-lab-content [content]="content"></app-app-and-lab-content>
    }
    @case ('lab') {
      <app-app-and-lab-content [content]="content"></app-app-and-lab-content>
    }
    @case ('customApp') {
      <app-app-and-lab-content [content]="content"></app-app-and-lab-content>
    }
    @case ('image') {
      <app-image-content [content]="content"></app-image-content>
    }
    @case ('video') {
      <app-video-content [content]="content" [phaseId]="phaseId"></app-video-content>
    }
    @case ('webPage') {
      <app-web-page-content [content]="content"></app-web-page-content>
    }
    @case ('file') {
      <app-file-content [content]="content"></app-file-content>
    }
    @case ('pdf') {
      <app-pdf-content [content]="content"></app-pdf-content>
    }
    @case ('notRecognized') {
      <div></div>
    }
    @default {
      <div>
        <h1>Unknown content type</h1>
        <p>Content type: {{ content?.contentType }}</p>
      </div>
    }
  }
</div>
